module.exports = __webpack_public_path__ + "media/images/shared/bg-teacher-03d57593ca3357db24d3aa44a0581bde.svg";